import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  ViewEncapsulation
} from '@angular/core';
import {
  Context,
  TaskEvent,
  Tarea,
  DynamicComponentForm,
  ConfigFinishDefault
} from '../../../shared';

@Component({
  selector: 'iw-example-docs',
  templateUrl: './example-docs.component.html',
  styleUrls: ['./example-docs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExampleDocsComponent extends DynamicComponentForm implements OnInit {
  // Define cuando abre la ventana de documentos
  wimdowDocs = false;
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<TaskEvent>;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Tarea actual
  task: Tarea;
  // Extensiones de los archivos permitidas
  extensions: Array<String> = ['jpg', 'png', 'pdf', 'docx', 'doc'];

  constructor() {
    super();
  }

  ngOnInit() {
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
  }

  /**
   * Finalizar la tarea.
   *
   * @param {boolean} res
   * @memberof DemoComponent
   */
  finish(res: boolean) {
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }
  /**
   * Actualizar informacion de la tarea respecto a los documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof ExampleDocsComponent
   */
  documentUpdate(data: any): any {
    this.ctx.task.documentos = data;
    this.updateTask(this.ctx.task);
  }
  /**
   * Controla el evento de cerrar la ventana de documentos
   *
   * @param {boolean} res
   * @memberof ExampleDocsComponent
   */
  closeDocs(res: boolean) {
    if (res) {
      this.wimdowDocs = false;
    }
  }
  /**
   * Àbre la ventana de docuemntos
   *
   * @memberof ExampleDocsComponent
   */
  openDocs() {
      this.wimdowDocs = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/all/example-docs/example-docs.component.ts